var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrendingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1655 2.80022C16.3937 2.80022 15.7702 2.17454 15.7702 1.40011C15.7702 0.625674 16.3937 0 17.1655 0H24.1421C24.9139 0 25.5374 0.625674 25.5374 1.40011V8.40066C25.5374 9.17509 24.9139 9.80077 24.1421 9.80077C23.3703 9.80077 22.7468 9.17509 22.7468 8.40066V4.78225L15.3603 12.1897C14.8153 12.7366 13.9345 12.7366 13.3895 12.1897L8.75439 7.58247L2.80382 13.5898C2.25877 14.1367 1.37536 14.1367 0.830405 13.5898C0.285535 13.0429 0.285535 12.1591 0.830405 11.6122L7.80819 4.61161C8.35324 4.06469 9.23403 4.06469 9.77908 4.61161L14.3749 9.21885L20.7715 2.76084L17.1655 2.80022Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingIcon);
export default __webpack_public_path__ + "static/media/trendingIcon.cbf39001dbcb631240741541a8810227.svg";
export { ForwardRef as ReactComponent };